import { APP_ROUTES } from "config/routes";

export interface CaseStudyLink {
  label: string;
  href: string;
}

// Single source of truth for the CASE STUDIES menu.
// Add a new case study here and it appears in both the desktop and mobile nav.
export const CASE_STUDIES: CaseStudyLink[] = [
  { label: "ADIDAS Y-3", href: APP_ROUTES.CASE_STUDY_ADIDAS_Y3 },
  { label: "PUMA", href: APP_ROUTES.CASE_STUDY_PUMA },
  { label: "POLYGON", href: APP_ROUTES.CASE_STUDY_POLYGON },
  { label: "CLOUT", href: APP_ROUTES.CASE_STUDY_CLOUT },
  { label: "LOCAL HEROES", href: APP_ROUTES.CASE_STUDY_LOCAL_HEROES },
  { label: "WIDZEW ŁÓDŹ", href: APP_ROUTES.CASE_STUDY_WIDZEW_LODZ },
  { label: "$MOG", href: APP_ROUTES.CASE_STUDY_MOG },
  { label: "REKT", href: APP_ROUTES.CASE_STUDY_REKT },
];
